/**
 * Canonical (lowercase) form of a content slug.
 *
 * `proxy.ts` 308s every non-lowercase pathname to its lowercase form, so the lowercase spelling is
 * the only one a visitor or crawler is ever served. Sanity, however, stores 64 boat slugs that
 * carry uppercase characters — Roman numerals and model codes such as `amels-altair-III-1974` or
 * `crn-5G-2011`. Left alone, the sitemap advertises the stored spelling, the middleware redirects
 * it, and the lowercase target 404s because the lookup matched the slug exactly (MDC-4221).
 *
 * Everything that emits or resolves a slug therefore agrees on this one form: `generateStaticParams`
 * prerenders it, the sitemaps advertise it, and `alternates.canonical` claims it. The lookup
 * queries match case-insensitively so the stored spelling still resolves.
 */
export const canonicalSlug = (slug: string): string => slug.toLowerCase();
